<section class="after-login">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-strip my-5">
                    <h2 class="text-primary">My Wishlist</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-box overflow-hidden">
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>PRODUCT IMAGE</th>
                                    <th>PRODUCT NAME</th>
                                    <th>PRICE</th>
                                    <th>STOCK STATUS</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (product of wishlists; track product; let i = $index) {

                                <tr>
                                    <td>
                                        <div class="img-box rounded-3 overflow-hidden">
                                            <img [src]="imagePath+product?.product_id+'/'+product?.cover_image"
                                                alt="{{product?.title}}" class="w-100 h-100">
                                        </div>
                                    </td>
                                    <td>
                                        <span>{{product.title | titlecase}}</span>
                                    </td>
                                    <td>
                                        <span>{{product?.real_price | currency}}</span>
                                    </td>
                                    <td>
                                        <span>{{product.in_stock?'In Stock':'Out Of Stock'}}</span>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center justify-content-end">
                                            <a [attr.disabled]="product.in_stock == 0"
                                                [ngbTooltip]="product.in_stock == 0?'Product is out of stock':''"
                                                (click)="addProductToCart(product)" class="btn btn-success">Add to
                                                cart</a>
                                            <a (click)="removeFromWishlist(product)"
                                                class="ms-3 delete-btn text-danger cursor-pointer">
                                                <i class="fa-solid fa-trash-can fs-5"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="4" class="text-center">No Records to Show!</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>